export default "__VITE_ASSET__Dfs0kWE___"